import Link from 'next/link';
import cn from 'classnames';
import {
  ContentPageNavigationItem,
  ContentPageNavigationHeading,
} from '@adapters/prismic/types/contentPage';
import NavigationLevel from './NavigationLevel';
import styles from './ContentPageNavigation.module.scss';

interface ContentPageNavigationProps {
  navigationStructure: ContentPageNavigationItem[];
  heading: ContentPageNavigationHeading;
  classNames?: string | string[];
}

const ContentPageNavigation = ({
  heading,
  navigationStructure,
  classNames,
}: ContentPageNavigationProps) => (
  <nav className={cn(classNames)}>
    <div className={styles.navHeadingContainer}>
      <Link href={heading.slug} className={styles.navHeading}>
        {heading.title}
      </Link>
    </div>

    <NavigationLevel navItems={navigationStructure} />
  </nav>
);

export default ContentPageNavigation;
